import axios from 'axios'
import router from '~/router'
import imWorkbenchWhitList from './whtieList/workbench'

export default function install(instance) {
  instance.interceptors.request.use(onRequest, onRequestError)
}

const CancelToken = axios.CancelToken
const singleMap = {}

const notWithWorkbenchParams = [
  '/crm-customer-service-app/knowledge/getTypeByWorkbenchId',
  '/ymm-file-app/fileUpload/preUpload',
  '/crm-customer-service-app/knowledge/getArticlesByWorkbenchId',
  '/crm-customer-service-app/knowledge/getArticlesBySearchKey'
]

function onRequest(config) {
  if (config.single) {
    const cancel = singleMap[typeof config.single === 'string' ? config.single : config.url]
    if (cancel) {
      cancel('cancel')
    }
    config.cancelToken = new CancelToken(c => (singleMap[config.url] = c))
  }
  if (!config.notWithWorkBenchId && !aimImWhiteList(config.url)) {
    const hashText = window.location.hash
    const authorityPath =
      hashText.includes('/simulate') ||
      hashText.includes('/crmcall') ||
      hashText.includes('/callout') ||
      hashText.includes('/personal/tempsave') // 外呼工作台 模拟弹屏 暂存不需要权限验证
    Object.assign(config.headers, {
      wokbenchid: _.get(router, 'history.current.query.workbenchId') || 2,
      authority: authorityPath ? 0 : 1
    })
  }
  config.data = config.data || {}
  setWorkbenchId(config)
  // notWithWorkBenchId, 当接口不需要workbenchId的时候可以将这个值设置为true，因为之前测试报过bug所以这么处理
  if (!aimNotWithWorkbench(config.url) && !config.data.workbenchId && !config.notWithWorkBenchId) {
    config.data.channelCode = window.workbenchId // 全局加上工作台id
  }
  if (
    config.method !== 'post' &&
    config.data.workbenchId &&
    config.url.indexOf('workbenchId') < 0 &&
    !config.notWithWorkBenchId
  ) {
    if (config.url.indexOf('?') > -1) {
      config.url = config.url + '&workbenchId=' + config.data.workbenchId
    } else {
      config.url = config.url + '?workbenchId=' + config.data.workbenchId
    }
  }
  return config
}

function aimNotWithWorkbench(url) {
  return notWithWorkbenchParams.some(path => {
    if (url.startsWith('http')) return url.includes(path)
    return path.includes(url)
  })
}

function onRequestError(error) {
  if (!axios.isCancel(error)) {
    return Promise.reject(error)
  }
}

function aimImWhiteList(url) {
  return imWorkbenchWhitList.some(path => {
    if (url.startsWith('http')) return url.includes(path)
    return path.includes(url)
  })
}

function setWorkbenchId(config) {
  const workbenchId = +(sessionStorage && sessionStorage.getItem('imWorkBenchId'))

  if (aimImWhiteList(config.url)) {
    config.data.workbenchId = workbenchId
    if (!config.notWithWorkBenchId) {
      Object.assign(config.headers, {
        wokbenchid: workbenchId,
        authority: 1
      })
    }
  }
}
